import { Route, Routes } from "react-router-dom";
import InsightsDashboard from "./InsightsDashboard";
import InsightsImport from "./InsightsImport";
import InsightsExplore from "./InsightsExplore";
import InsightsAsk from "./InsightsAsk";
import InsightsCategory from "./InsightsCategory";

const Insights = () => {
  return (
    <Routes>
      <Route path="/" element={<InsightsDashboard />} />
      <Route path="import" element={<InsightsImport />} />
      <Route path="explore" element={<InsightsExplore />} />
      <Route path="ask" element={<InsightsAsk />} />
      <Route path="category/:categoryName" element={<InsightsCategory />} />
    </Routes>
  );
};

export default Insights;
